import {useCallback, useContext} from "react";
import {
    IDeal,
    IMeeting,
    IMeetingCount,
    IMeetings,
    IPlaylist,
    ITranscript,
    ITranscriptInfo,
    Seeking,
    ObjectContext,
    SelectedTranscript,
} from "./../context/AppStore";
import {getColors} from "../utils/Utility";
import {DictionaryItem} from "../types";

export interface ObjectHook {
    meetings: IMeeting[];
    searchMeetings: IMeetings[];
    meetingCount: IMeetingCount[];
    transcripts: ITranscriptInfo[];
    searchedTranscripts: any[];
    showSearch: boolean;
    loading: boolean;
    selectedMeeting: IMeeting;
    redirectMeetingId: String | undefined;
    meetingSortBy: string;
    dealSortBy: string;
    playlistSortBy: string;
    deals: IDeal[];
    dealId: string;
    autoScroll: boolean;
    notesData: any[];
    setAutoScroll: (autoScroll: boolean) => void;
    setDeals: (deals: IDeal[]) => void;
    setDealId: (dealId: string) => void;
    selectedDeal: IDeal;
    setSelectedDeal: (selectedDeal: IDeal) => void;
    playlist: IPlaylist[];
    setPlayList: (playlist: IPlaylist[]) => void;
    commentedData: ITranscriptInfo[],
    setCommentedData: (commentedData: ITranscriptInfo[]) => void;
    currentModule: String;
    currentLeftPanel: String;
    currentTab: String;
    selectedTranscript: SelectedTranscript;
    filterByTranscriptUser: string;
    colors: DictionaryItem<string>;
    timeStampsArray: any[];
    reset: () => void;
    resetMeetings: (meetings: IMeeting[]) => void;
    resetPlaylist: (playlist: IPlaylist[]) => void;
    resetDeals: (deals: IDeal[]) => void;
    setMeetings: (meetings: IMeeting[]) => void;
    setSearchMeetings: (searchMeetings: IMeetings[]) => void;
    setSearchedMeetings: (searchedMeetings: any[]) => void;
    setShowNavSearch: (showNavSearch: boolean) => void;
    setMeeting: (meeting: IMeeting) => void;
    setTranscripts: (transcripts: ITranscriptInfo[]) => void;
    setSearchedTranscripts: (searchedTranscripts: any[]) => void;
    setMeetingCount: (meetingCount: any[]) => void;
    setShowSearch: (showSearch: boolean) => void;
    setLoading: (loading: boolean) => void;
    setSelectedMeeting: (selectedMeetingId: string | null) => void;
    setSelectedTranscript: (selectedTranscript: SelectedTranscript) => void;
    setFilterByTranscriptUser: (filterByTranscriptUser: String) => void;
    setCurrentModule: (module: String) => void;
    setCurrentTab: (tabs: String) => void;
    setMeetingSortBy: (sortBy: string) => void;
    setDealSortBy: (sortBy: string) => void;
    setPlaylistSortBy: (sortBy: string) => void;
    setCurrentLeftPanel: (panel: String) => void;
    updateMeeting: (meetings: IMeeting) => void;
    isPlaying: boolean;
    setIsPlaying: (isPlaying: boolean) => void;
    isPaused: boolean;
    setIsPaused: (isPaused: boolean) => void;
    seek: Number;
    setSeek: (seek: Number) => void;
    seeking: Seeking;
    setSeeking: (seeking: Seeking) => void;
    changeMeeting: () => void;
    transcriptsWithComment: boolean;
    showTranscriptsWithComment: (transcriptsWithComment: boolean) => void;
    setRedirectMeetingId: (id: String) => void;
    updateMeetingData: (newData: any) => void;
    updateTranscriptSpeaker: (changedNames: any) => void;
    setMeetingsAndSearchMeetings: (meetings: IMeeting[], searchMeetings: IMeetings[]) => void;
    setNotesData: (newData: any) => void;
    setTimeStampsArray: (newData: any) => void;
    reSetTimeStampsArray: (newData?: any) => void;
    reloadTransctipt: boolean;
    setReloadTransctipt: (newData: boolean) => void;
    totalMeetingCount: number;
    setTotalMeetingCount: (totalMeetingCount: any) => void;
}

const useObjectHook = (): ObjectHook => {
    const [state, setState] = useContext(ObjectContext);

    const reset = useCallback(() => {
        setState((prvState: any) => ({
            ...prvState,
            filterByTranscriptUser: "",
            selectedTranscript: undefined,
            transcripts: [],
            searchedTranscripts: [],
            loading: false,
            selectedMeeting: undefined,
            timeStampsArray: []
        }));
    }, [setState]);

    const updateTranscriptSpeaker = useCallback((changedNames: any) => {
        if (changedNames) {
            setState((prvState: any) => {
                var transcripts: ITranscriptInfo[] = [...prvState.transcripts];
                changedNames.map(value => {
                    transcripts.map((transcript, index) => {
                        if (transcript.name === value.oldName) {
                            var jsonObjString = JSON.stringify(transcript);
                            var jsonObj = JSON.parse(jsonObjString);
                            jsonObj.name = value.newName;
                            transcripts[index] = jsonObj;
                        }
                    });
                });
                var jsonString = JSON.stringify(transcripts);
                var updatedAtrry = JSON.parse(jsonString);
                let talkTrack = [...prvState.selectedMeeting?.analytics?.talktrack]
                changedNames.map((e) => {
                    talkTrack.map((value, index) => {
                        if (value.userid === e.oldName) {
                            var jsonObjString = JSON.stringify(value);
                            var jsonObj = JSON.parse(jsonObjString);
                            jsonObj.userid = e.newName;
                            talkTrack[index] = jsonObj;
                        }
                    });
                });
                let newSelectedMeeting = {
                    ...prvState.selectedMeeting,
                    analytics: {
                        ...prvState.selectedMeeting.analytics,
                        talktrack: talkTrack,
                    }
                }
                return {
                    ...prvState,
                    transcripts: updatedAtrry,
                    selectedMeeting: newSelectedMeeting
                };
            });
        }
    }, [setState]);

    const updateMeetingData = useCallback((meeting: IMeeting) => {
        if (meeting) {
            setState((prvState: any) => {
                const meetings: IMeeting[] = [...prvState.meetings];
                const searchMeetings: IMeetings[] = [...prvState.searchMeetings];

                let prvMeetingIndex = meetings.findIndex(
                    (meetingItem: IMeeting) =>
                        meetingItem.id === meeting.id
                );
                let prvSearchMeetingIndex = searchMeetings.findIndex(
                    (searchMeetingItem: IMeetings) =>
                        searchMeetingItem.meeting && searchMeetingItem.meeting.id === meeting.id
                );

                if (prvMeetingIndex > -1 && prvSearchMeetingIndex > -1 ) {
                    meetings[prvMeetingIndex] = meeting;
                    searchMeetings[prvSearchMeetingIndex] = {...searchMeetings[prvSearchMeetingIndex], meeting: meeting};

                    return {
                        ...prvState,
                        meetings: meetings,
                        searchMeetings: searchMeetings,
                        isPlaying: false,
                        autoScroll: false,
                        selectedMeeting: meeting
                    };
                }
                return prvState;
            });
        }
    }, [setState]);

    const setSelectedMeeting: any = useCallback((selectedMeetingId: string) => {
        setState((prvState: any) => {
            if (prvState.selectedMeeting?.id === selectedMeetingId) return prvState;
            const meetings: IMeeting[] = prvState.meetings;
            let newMeeting: IMeeting | undefined;
            if (meetings !== null) {
                const meeting: IMeeting[] = meetings.filter(
                    (x) => x.id === selectedMeetingId
                );
                if (meeting.length > 0) {
                    newMeeting = meeting[0];
                }
            }
            return {
                ...prvState,
                selectedMeeting1: "newMeeting",
                filterByTranscriptUser: "",
                selectedTranscript: undefined,
                transcripts: [],
                selectedMeeting: newMeeting,
                autoScroll: false,
                isPlaying: false,
            };
        });
    }, [setState]);

    const setMeeting: any = useCallback((selectedMeeting: IMeeting) => {
        setState((prvState: any) => {
            // Only reset transcripts when switching to a different meeting
            const meetingChanged = prvState.selectedMeeting?.id !== selectedMeeting?.id;
            return {
                ...prvState,
                filterByTranscriptUser: "",
                redirectMeetingId: undefined,
                selectedTranscript: meetingChanged ? undefined : prvState.selectedTranscript,
                transcripts: meetingChanged ? [] : prvState.transcripts,
                selectedMeeting: selectedMeeting,
            };
        });
    }, [setState]);

    const setSelectedTranscript: any = useCallback((
        selectedTranscript: SelectedTranscript
    ) => {
        setState((prvState: any) => ({
            ...prvState,
            selectedTranscript: selectedTranscript,
        }));
    }, [setState]);

    const resetMeetings: any = useCallback((meetings: IMeeting[]) => {
        setState((prvState: any) => {
            if (meetings === prvState.meetings) return prvState;
            return {
                ...prvState,
                meetings: meetings,
                isPlaying: false,
                autoScroll: false,
            };
        });
    }, [setState]);

    const resetPlaylist: any = useCallback((playlist: IPlaylist[]) => {
        setState((prvState: any) => {
            if (playlist === prvState.playlist) return prvState;
            return {...prvState, playlist: playlist};
        });
    }, [setState]);

    const resetDeals: any = useCallback((deals: IDeal[]) => {
        setState((prvState: any) => {
            if (deals === prvState.deals) return prvState;
            return {...prvState, deals: deals};
        });
    }, [setState]);

    const setMeetings: any = useCallback((meetings: IMeeting[]) => {
        setState((prvState: any) => {
            if (meetings === prvState.meetings) return prvState;
            return {
                ...prvState,
                meetings: meetings,
                selectedTranscript: undefined,
                transcripts: [],
                isPlaying: false,
                autoScroll: false,
                selectedMeeting: (meetings && meetings.length > 0) ? (meetings[0] as IMeeting) : null,
            };
        });
    }, [setState]);

    const setSearchMeetings: any = useCallback((searchMeetings: IMeetings[]) => {
        setState((prvState: any) => {
            if (searchMeetings === prvState.searchMeetings) return prvState;
            return {
                ...prvState,
                searchMeetings: searchMeetings
            };
        });
    }, [setState]);

    const setMeetingsAndSearchMeetings: any = useCallback((newMeetings: IMeetings[], newSearchMeetings: IMeetings[]) => {
        setState((prvState: any) => ({
            ...prvState,
            meetings: newMeetings,
            loading: false,
            searchMeetings: newSearchMeetings,
        }));
    }, [setState]);

    const setMeetingCount: any = useCallback((meetingCount: IMeetingCount[]) => {
        setState((prvState: any) => {
            if (meetingCount === prvState.meetingCount) return prvState;
            return {
                ...prvState,
                meetingCount: meetingCount
            };
        });
    }, [setState]);

    const setTotalMeetingCount: any = useCallback((totalMeetingCount: Number) => {
        setState((prvState: any) => {
            if (totalMeetingCount === prvState.totalMeetingCount) return prvState;
            return {
                ...prvState,
                totalMeetingCount: totalMeetingCount
            };
        });
    }, [setState]);

    const setSearchedMeetings: any = useCallback((searchedMeetings: any[]) => {
        setState((prvState: any) => ({
            ...prvState,
            searchedMeetings,
            showNavSearch: true,
        }));
    }, [setState]);

    const setShowNavSearch: any = useCallback((showNavSearch: boolean) => {
        setState((prvState: any) => ({
            ...prvState,
            showNavSearch,
            searchedMeetings: [],
        }));
    }, [setState]);

    const updateMeeting: any = useCallback((meeting: IMeeting) => {
        if (meeting) {
            setState((prvState: any) => {
                let prvMeetingIndex = prvState.meetings.findIndex(
                    (meetingItem: IMeeting) =>
                        meetingItem.providerMeetingId === meeting.providerMeetingId
                );
                if (prvMeetingIndex > -1) {
                    let meetings = [...prvState.meetings];
                    meetings.splice(prvMeetingIndex, 1, meeting);
                    return {
                        ...prvState,
                        meetings: meetings,
                        isPlaying: false,
                        autoScroll: false,
                    };
                }
                return prvState;
            });
        }
    }, [setState]);

    const setTranscripts: any = useCallback((transcripts: ITranscript[]) => {
        setState((prvState: any) => ({
            ...prvState,
            transcripts: transcripts,
            selectedTranscript: prvState.selectedTranscript && prvState.selectedTranscript.transcript
                ? prvState.selectedTranscript
                : {
                    transcript: transcripts && transcripts.length > 0 ? transcripts[0] : undefined,
                },
            colors: getColors(transcripts, "name"),
        }));
    }, [setState]);

    const setSearchedTranscripts: any = useCallback((searchedTranscripts: any[]) => {
        setState((prvState: any) => ({
            ...prvState,
            searchedTranscripts,
            showSearch: true,
        }));
    }, [setState]);

    const setShowSearch: any = useCallback((showSearch: boolean) => {
        setState((prvState: any) => ({
            ...prvState,
            showSearch,
            searchedTranscripts: [],
        }));
    }, [setState]);

    const setLoading: any = useCallback((loading: boolean) => {
        setState((prvState: any) => ({...prvState, loading}));
    }, [setState]);

    const setFilterByTranscriptUser: any = useCallback((filterByTranscriptUser: String) => {
        setState((prvState: any) => ({
            ...prvState,
            filterByTranscriptUser: filterByTranscriptUser,
        }));
    }, [setState]);

    const setDeals: any = useCallback((deals: IDeal[]) => {
        setState((prvState: any) => {
            if (deals === prvState.deals) return prvState;
            return {...prvState, deals: deals};
        });
    }, [setState]);

    const setDealId: any = useCallback((dealId: string) => {
        if (dealId) {
            setState((prevState: any) => ({...prevState, dealId: dealId}));
        }
    }, [setState]);

    const setSelectedDeal: any = useCallback((selectedDeal: string) => {
        if (selectedDeal) {
            setState((prevState: any) => ({...prevState, selectedDeal: selectedDeal}));
        }
    }, [setState]);

    const setCurrentModule: any = useCallback((currentModule: String) => {
        setState((prvState: any) => ({...prvState, currentModule: currentModule}));
    }, [setState]);

    const setCurrentTab: any = useCallback((currentTab: String) => {
        setState((prvState: any) => ({
            ...prvState,
            currentTab: currentTab,
            isPlaying: false,
            autoScroll: false,
            transcriptsWithComment: false,
        }));
    }, [setState]);

    const setCurrentLeftPanel: any = useCallback((currentLeftPanel: String) => {
        setState((prvState: any) => ({
            ...prvState,
            currentLeftPanel: currentLeftPanel,
            isPlaying: false,
            autoScroll: false,
            transcriptsWithComment: false,
        }));
    }, [setState]);

    const setPlayList: any = useCallback((playlist: IPlaylist) => {
        setState((prevState: any) => ({...prevState, playlist: playlist}));
    }, [setState]);

    const setCommentedData: any = useCallback((commentedData: ITranscriptInfo[]) => {
        setState((prevState: any) => ({...prevState, commentedData}));
    }, [setState]);

    const setMeetingSortBy = useCallback((sortBy: string) => {
        setState((prvState: any) => ({...prvState, meetingSortBy: sortBy}));
    }, [setState]);

    const setDealSortBy = useCallback((sortBy: string) => {
        setState((prvState: any) => ({...prvState, dealSortBy: sortBy}));
    }, [setState]);

    const setPlaylistSortBy = useCallback((sortBy: string) => {
        setState((prvState: any) => ({...prvState, playlistSortBy: sortBy}));
    }, [setState]);

    const setAutoScroll = useCallback((autoScroll: boolean) => {
        setState((prvState: any) => ({...prvState, autoScroll}));
    }, [setState]);

    const setReloadTransctipt = useCallback((reloadTransctipt: boolean) => {
        setState((prvState: any) => ({...prvState, reloadTransctipt}));
    }, [setState]);

    const setIsPlaying = useCallback((isPlaying: boolean) => {
        setState((prvState: any) => ({
            ...prvState,
            isPlaying: isPlaying,
            autoScroll: isPlaying,
        }));
    }, [setState]);

    const setIsPaused = useCallback((isPaused: boolean) => {
        setState((prvState: any) => ({
            ...prvState,
            isPaused: isPaused,
        }));
    }, [setState]);

    const changeMeeting = useCallback(() => {
        setState((prvState: any) => ({
            ...prvState,
            isPlaying: false,
            autoScroll: false,
            transcriptsWithComment: false,
        }));
    }, [setState]);

    const showTranscriptsWithComment = useCallback((isFiltered: boolean) => {
        setState((prvState: any) => ({
            ...prvState,
            transcriptsWithComment: isFiltered
        }));
    }, [setState]);

    const setRedirectMeetingId = useCallback((id: String) => {
        setState((prvState: any) => ({...prvState, redirectMeetingId: id}));
    }, [setState]);

    const setNotesData = useCallback((newData: any) => {
        setState((prvState: any) => ({...prvState, currentModule: "test", notesData: newData}));
    }, [setState]);

    const setSeek = useCallback((seek: Number) => {
        setState((prvState: any) => ({
            ...prvState,
            seek: seek,
        }));
    }, [setState]);

    const setSeeking = useCallback((seeking: Seeking) => {
        setState((prvState: any) => ({
            ...prvState,
            seeking: seeking,
        }));
    }, [setState]);

    const setTimeStampsArray = useCallback((newData: any) => {
        setState((prvState: any) => ({...prvState, timeStampsArray: [...prvState.timeStampsArray, newData]}));
    }, [setState]);

    const reSetTimeStampsArray = useCallback((newData: any = []) => {
        setState((prvState: any) => ({...prvState, timeStampsArray: newData}));
    }, [setState]);

    return {
        commentedData: state.commentedData,
        setCommentedData,
        currentLeftPanel: state.currentLeftPanel,
        meetings: state.meetings,
        searchMeetings: state.searchMeetings,
        meetingCount: state.meetingCount,
        transcripts: state.transcripts,
        searchedTranscripts: state.searchedTranscripts,
        showSearch: state.showSearch,
        loading: state.loading,
        redirectMeetingId: state.redirectMeetingId,
        selectedMeeting: state.selectedMeeting,
        selectedTranscript: state.selectedTranscript,
        filterByTranscriptUser: state.filterByTranscriptUser,
        colors: state.colors,
        currentModule: state.currentModule,
        currentTab: state.currentTab,
        setMeetings,
        setSearchMeetings,
        setSearchedMeetings,
        setTranscripts,
        setSearchedTranscripts,
        setShowSearch,
        setShowNavSearch,
        setMeetingCount,
        setLoading,
        setSelectedMeeting,
        setSelectedTranscript,
        setFilterByTranscriptUser,
        updateMeeting,
        deals: state.deals,
        setDeals,
        setDealId,
        dealId: state.dealId,
        autoScroll: state.autoScroll,
        setAutoScroll,
        selectedDeal: state.selectedDeal,
        setSelectedDeal,
        setMeeting,
        setCurrentModule,
        setCurrentTab,
        setCurrentLeftPanel,
        setPlayList,
        playlist: state.playlist,
        resetMeetings,
        reset,
        setMeetingSortBy,
        meetingSortBy: state.meetingSortBy,
        setDealSortBy,
        dealSortBy: state.dealSortBy,
        setPlaylistSortBy,
        playlistSortBy: state.playlistSortBy,
        resetPlaylist,
        resetDeals,
        isPlaying: state.isPlaying,
        setIsPlaying,
        isPaused: state.isPaused,
        setIsPaused,
        changeMeeting,
        transcriptsWithComment: state.transcriptsWithComment,
        showTranscriptsWithComment,
        setRedirectMeetingId,
        updateMeetingData,
        updateTranscriptSpeaker,
        setMeetingsAndSearchMeetings,
        notesData: state.notesData,
        setNotesData,
        setSeek,
        seek: state.seek,
        setSeeking,
        seeking: state.seeking,
        setTimeStampsArray,
        reSetTimeStampsArray,
        timeStampsArray: state.timeStampsArray,
        reloadTransctipt: state.reloadTransctipt,
        setReloadTransctipt,
        totalMeetingCount: state.totalMeetingCount,
        setTotalMeetingCount,
    };
};

export default useObjectHook;
